/**
 * Environment Variable Configuration
 */
import { logErrorDebug } from './debug/debugLogging'

export const {
  /*
   * Base url of react app
   * e.g. /build-iconic/
   */
  PUBLIC_URL,

  /*
   * Node development / production setting
   */
  NODE_ENV,

  /*
   * Document id in Firestore from which to fetch product data
   * e.g. dev
   */
  REACT_APP_PRODUCTS_ENVIRONMENT,

  /*
   * Base url for product images
   * e.g. absolute S3 bucket url, or local url like '/product-images'
   */
  REACT_APP_IMAGE_BASE_URL,

  /*
   * Whether to allow debug mode to be enabled with ?debug query value
   */
  REACT_APP_DEBUG_MODE_ENABLED,

  /*
   * Whether to allow Cash Sales integration with clipsal.com
   */
  REACT_APP_ENABLE_CASH_SALES_INTEGRATION,


  REACT_APP_ANALYTICS_PAGE_VIEW_ENVIRONMENT,
} = process.env

/**
 * @Deprecated not being implemented
 */
export const ENABLE_SIMULATED_LOGIN_FLOW = process.env.REACT_APP_ENABLE_SIMULATED_LOGIN_FLOW === 'true'

export const ENABLE_ELECTRICIAN_VIEW = process.env.REACT_APP_ENABLE_ELECTRICIAN_VIEW === 'true'

export function getAnalyticsPageViewEnvironment() {
  if (
    REACT_APP_ANALYTICS_PAGE_VIEW_ENVIRONMENT === 'production'
    || REACT_APP_ANALYTICS_PAGE_VIEW_ENVIRONMENT === 'development'
  ) {
    return REACT_APP_ANALYTICS_PAGE_VIEW_ENVIRONMENT
  } else {
    logErrorDebug('env', `REACT_APP_ANALYTICS_PAGE_VIEW_ENVIRONMENT has invalid value: "${REACT_APP_ANALYTICS_PAGE_VIEW_ENVIRONMENT ?? '<undefined>'}"`)
    return 'development'
  }
}

export function isDev(): boolean {
  return NODE_ENV === 'development'
}

export function isDebugModeSupported(): boolean {
  return REACT_APP_DEBUG_MODE_ENABLED === 'true'
}
